import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { axiosGetData } from "@shared/api/clients";
import { TermsOfUseResponse } from "./terms-of-use.types";

const TERMS_OF_USE_ENDPOINT = "v1/legal-documents/terms-of-use";

export const TERMS_OF_USE_QUERY_KEY = [
  "legal-documents",
  "TERMS_OF_USE",
] as const;

export const useTermsOfUseQuery = () => {
  return useQuery({
    queryKey: TERMS_OF_USE_QUERY_KEY,
    queryFn: () => axiosGetData<TermsOfUseResponse>(TERMS_OF_USE_ENDPOINT),
    retry: (_failureCount, error) =>
      (error as AxiosError)?.response?.status !== 404,
  });
};
